import { SelectionInfo } from 'dragonmouse-shared/devigner';
import { Frame } from 'dragonmouse-shared/interfaces';
import { getElementName } from 'utils';
import Comments from '../Comments';
import * as S from './styles';

interface ElementInfoProps {
	frame: Frame;
	selectionInfo: SelectionInfo;
}

const ElementInfo = ({ frame, selectionInfo }: ElementInfoProps) => {
	const elementName = getElementName(selectionInfo.element);
	const isDesignSystemElement = selectionInfo.element.tagName.toLowerCase().startsWith('ds-');
	const dsTagName = isDesignSystemElement ? `<${selectionInfo.element.tagName.toLowerCase()}>` : null;
	const elementId = selectionInfo.dataset?.mcElementId ?? selectionInfo.element.id;

	return (
		<S.Container>
			<S.HeaderBase>
				<div>
					<S.ElementName>{elementName}</S.ElementName>
					{dsTagName && <S.DsComponentName>{dsTagName}</S.DsComponentName>}
				</div>
			</S.HeaderBase>
			<Comments frame={frame} filterElementId={elementId} />
		</S.Container>
	);
};

export default ElementInfo;
